/**
 * Single-account session storage. The API treats every request in isolation
 * by Bearer token; this module just persists that token in localStorage.
 */

const TOKEN_KEY = 'emissaries_session_token';

export function getSessionToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function setSessionToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * On OAuth callback the API places the session token in the URL fragment
 * (#session_token=<token>). Must run synchronously before React mounts so
 * the first `me` query picks up the new token.
 */
export function captureSessionToken() {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash;
  if (!hash.includes('session_token=')) return;
  const match = hash.match(/session_token=([^&]+)/);
  if (match?.[1]) {
    setSessionToken(decodeURIComponent(match[1]));
  }
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
